<template>
  <div 
    class="page col w-100 h-100 pt4 gap4" 
    :class="{
      'm-auto': centered, 
      p0: noPad,
      p4: $mq == 'phone' && !noPad,
      p8: $mq != 'phone' && !noPad
    }"
    :style="{width}"
  >
    <slot name="breadcrumbs" />
    <Row 
      v-if="$slots.header || $slots.right" 
      between
      :class="{'col gap3': $mq == 'phone'}"
    >
      <!-- Левая часть шапки - опциональная иконка "Назад", заголовок (текстовый или функция) -->
      <Row>
        <SvgIcon v-if="showBack" icon-name="chevron_big_left" :width="24" class="pointer mr2" @click="$router.go(-1)" />
        <div v-if="$slots.header" class="text-24 lh-28 semibold">
          <!-- Заголовок - либо строковый либо слот, когда не задан пропс header -->
          <slot name="header" />
        </div>
        <div v-else-if="header" class="f-align-center text-24 lh-28 semibold">
          {{ typeof header == 'function' ? header() : $t(header) }}
        </div>
        <div v-else></div>
      </Row>
      <!-- Правая часть шапки - опциональный слот для кнопок или поиска -->
      <div
        class="right-side"
        :class="$mq == 'phone' ? 'w-100' : 'f-align-center'"
      >
        <slot name="right" />
      </div>
    </Row>
    <!-- Если нет слотов ни для левой ни для правой части шапки -->
    <Row v-else>
      <!-- Надо показать кнопку "Назад" -->
      <SvgIcon v-if="showBack" icon-name="chevron_big_left" :width="24" class="pointer mr2" @click="$router.go(-1)" />
      <!-- Заголовок - либо строковый либо функция -->
      <div v-if="header" class="f-align-center text-24 lh-28 semibold">
        {{ typeof header == 'function' ? header() : $t(header) }}
      </div>
    </Row>
        
    <!-- Основной контент страницы - либо слот, либо текст "Загрузка..." -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppPage',
  props: {
    noPad: { type: Boolean, default: false }, // убрать отступы
    // строковый заголовок либо функция если не надо переводить
    header: {
      type: [String,Function]
    },
    width: { type: String, default: '' },
    centered: { type: Boolean, default: false },
    showBack: { type: Boolean, default: false },
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/vars'

.page
  position relative
  background-color var(--bg-color) // $bg-blue
  &.p0
    padding 0

  @media (max-width: $phone) {
    margin: 0;
    padding: 16px;
  }
  // @media (min-width: $phone + 1px)
  //   margin 20px 20px 0 20px
  // @media (min-width: $tablet + 1px)
  //   margin 10px 30px 50px 30px
</style>